/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
} from './UserDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfUserDto
 */
export interface ODataPostProcessedResultsOfUserDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfUserDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof ODataPostProcessedResultsOfUserDto
     */
    value?: Array<UserDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfUserDto
     */
    $type?: ODataPostProcessedResultsOfUserDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfUserDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfUserDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedAuthorizationUsersDtoUserDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.Authorization.Users.Dto.UserDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfUserDtoTypeEnum = typeof ODataPostProcessedResultsOfUserDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfUserDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfUserDto interface.
 */
export function instanceOfODataPostProcessedResultsOfUserDto(value?: unknown): value is ODataPostProcessedResultsOfUserDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfUserDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfUserDtoFromJSON(json: any): ODataPostProcessedResultsOfUserDto {
    return ODataPostProcessedResultsOfUserDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(UserDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfUserDtoToJSON(value?: ODataPostProcessedResultsOfUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(UserDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

